import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { IGranteePortalResults  } from "../../baseWorker";
import { IGranteeHouseholdsServed } from "../utility";

interface BenefitTargetingCsvProps {
     granteePortalResults: IGranteePortalResults;
     granteeHouseholdsServed: IGranteeHouseholdsServed[];
}

function BenefitTargetingCsv({ granteePortalResults, granteeHouseholdsServed }: BenefitTargetingCsvProps) {
     const granteeColumnName = granteePortalResults.columnNames[0];
     const indexColumnName = granteePortalResults.columnNames[1];

     let firstRowArray: any = [];
     firstRowArray.push(granteeColumnName);
     firstRowArray.push(indexColumnName);
     firstRowArray.push('Number of Bill Payment Assisted Households');
     firstRowArray.push('Number of Bill Payment Assisted Households with Complete Performance Data');
     firstRowArray.push('Percentage of Bill Payment Assisted Households with Complete Performance Data');

     const csvData = [firstRowArray];

     granteePortalResults.reportData.map( (row) => {
          //create an array of values
          let valueArray:any[] = [];
          valueArray.push(row[granteeColumnName]);
          valueArray.push(row[indexColumnName]);
          let grServed = granteeHouseholdsServed.filter(gr => gr.GranteeName == row[granteeColumnName])[0];
          valueArray.push(grServed.HouseholdsAssisted.toLocaleString());
          valueArray.push(grServed.HouseholdsCompleteData.toLocaleString());
          valueArray.push(grServed.PercentCompleteDataString);
          csvData.push(Object.values(valueArray));
     });

     return (
          <CSVLink data={csvData} filename="BenefitTargetingComparison.csv" className="dataButton">Download as CSV</CSVLink>
     );
}

export default BenefitTargetingCsv;
